import script from "./login.vue?vue&type=script&lang=tsx&setup=true"
export * from "./login.vue?vue&type=script&lang=tsx&setup=true"

import "./login.vue?vue&type=style&index=0&id=3f62049e&lang=scss"

const __exports__ = script;

export default __exports__